export enum ContestType {
    Team = 'Team',
    Organizational = 'Organizational'
}
